// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__PM1XY","selected":"Chip_selected__w2jJD"};